const source = 'podsDataTable'

function downloadDichiarazioneIva () {

  const keys = Object.keys(this.filtered.items).filter((s) => s == source)
  if(keys.length > 0){
    const items = this.filtered.items[source]

    this.$eventBus.emit('show-dialog-page', {
      page: 'pods-dichiarazione-iva',
      title: 'Dichiarazione Iva',
      data: items,
      maximize: false,

    })
  } 
}

export default {
  'bindTo': 'this',
  'method': downloadDichiarazioneIva,
}
